import { Role } from "../../../helpers/role";
import store from "../../../../store/index";
const { code } = store.getters.dashboardRole;
console.log(code === "dd.verifier");
export const DistributorMenu = [
  {
    title: "Home",
    icon: "mdi-view-dashboard",
    to: "",
    code: "home",
    role: [Role.Distributor],
  },

  {
    title: "Dealer",
    icon: "mdi-chart-line",
    role: [Role.Distributor],
    code: "main-Dealer",
    submenu: [
      {
        title: "List",
        icon: "",
        to: "dealer-list",
        code: "Dealer-List",
        role: [Role.Distributor],
      },

      {
        title: "Pending Verification",
        icon: "",
        to: "distributor-dealer-pending-approval",
        code: "Dealer-List",
        role: [Role.Distributor],
        data: ["dd.verifier"]
      },

      {
        title: "Pending Approval",
        icon: "",
        to: "distributor-dealer-pending-approval",
        code: "Dealer-List",
        role: [Role.Distributor],
        data: ["dd.approver"]
      },

      // {
      //   title: "Denied",
      //   icon: "",
      //   to: "declined-dealer",
      //   code: "Dealer-List",
      //   role: [Role.Distributor],
      // },

      // {
      //   title: "Denied",
      //   icon: "",
      //   to: "distributor-denied",
      //   code: "distributor-denied",
      //   role: [Role.Distributor],
      // },
    ],
  },

  {
    title: "Dealer Top-up",
    icon: "mdi-email-receive-outline",
    code: "main-Dealer-TopUp",
    role: [Role.Distributor],
    submenu: [
      {
        title: "Pending Verification",
        icon: "",
        to: "distributor-dealer-topUp-Pending",
        code: "main-Dealer-TopUp-Pending",
        role: [Role.Distributor],
        data: ["dd.verifier"]
      },

      {
        title: "Pending Approval",
        icon: "",
        to: "distributor-dealer-topUp-Pending",
        code: "main-Dealer-TopUp-Pending",
        role: [Role.Distributor],
        data: ["dd.approver"]
      },
      // {
      //   title: "History",
      //   icon: "",
      //   to: "distributor-dealer-topUp-History",
      //   code: "main-Dealer-TopUp-History",
      //   role: [Role.Distributor],
      // },
    ],
  },
  {
    title: "Distributor Top-up Request",
    icon: "mdi-email-receive-outline",
    code: "main-SP-Topup",
    role: [Role.Distributor],
    submenu: [
      {
        title: "Request Top-up",
        icon: "",
        to: "Distributor-serviceProvider-Request",
        code: "main-SP-Topup-Request",
        role: [Role.Distributor],
      },
      {
        title: "Pending Verification",
        icon: "",
        to: "Distributor-serviceProvider-Pending",
        code: "main-SP-TopUp-Pending",
        role: [Role.Distributor],
        data: ["dd.verifier"]
      },

      {
        title: "Pending Approval",
        icon: "",
        to: "Distributor-serviceProvider-Pending",
        code: "main-SP-TopUp-Pending",
        role: [Role.Distributor],
        data: ["dd.approver"]
      },

      {
        title: "History",
        icon: "",
        to: "Distributor-serviceProvider-History",
        code: "main-SP-TopUp-History",
        role: [Role.Distributor],
      },
    ],
  },

  {
    title: "Banks",
    icon: "mdi-bank",
    to: "list-of-banks",
    code: "list-of-banks",
    role: [Role.Distributor],
  },

  {
    title: "Revenue Report",
    icon: "mdi-currency-usd",
    to: "Distributor-RevenueRPT",
    code: "main-Revenue-RPT",
    role: [Role.Distributor],
  },
  {
    title: "Accounts",
    icon: "mdi-email-receive-outline",
    code: "accounts",
    role: [Role.Distributor],
    submenu: [
      {
        title: "List",
        icon: "",
        to: "accounts",
        code: "accounts",
        role: [Role.Distributor],
      },
      {
        title: "Create",
        icon: "",
        to: "create-account",
        code: "create-account",
        role: [Role.Distributor],
      },
    ],
  },

];
